var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-expand-arrows-alt",
    "data-name": "Icon awesome-expand-arrows-alt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-expand-arrows-alt-2",
    "data-name": "Icon awesome-expand-arrows-alt",
    d: "M21.5,17.223V22.6a1.149,1.149,0,0,1-1.152,1.152H14.973a1.153,1.153,0,0,1-.816-1.968l1.737-1.737L10.75,14.9,5.6,20.05l1.739,1.732a1.153,1.153,0,0,1-.816,1.968H1.152A1.149,1.149,0,0,1,0,22.6V17.223a1.153,1.153,0,0,1,1.968-.816L3.7,18.145,8.852,13,3.7,7.851,1.968,9.593A1.153,1.153,0,0,1,0,8.777V3.4A1.149,1.149,0,0,1,1.152,2.25H6.527a1.153,1.153,0,0,1,.816,1.968L5.605,5.955,10.75,11.1,15.9,5.95,14.157,4.218a1.153,1.153,0,0,1,.816-1.968h5.375A1.149,1.149,0,0,1,21.5,3.4V8.777a1.153,1.153,0,0,1-1.968.816L17.8,7.855,12.648,13,17.8,18.149l1.736-1.737A1.151,1.151,0,0,1,21.5,17.223Z",
    transform: "translate(0 -2.25)",
    fill: "#b58156"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaIcon);
export default __webpack_public_path__ + "static/media/area-icon.a6853548fd0bee02f4fcd1a05beb087e.svg";
export { ForwardRef as ReactComponent };